import { DeviceType } from '../../types/commonTypes';
import { DeviceState } from './types';

export const DeviceStateAdapter = async (
  deviceType: DeviceType,
  requestDeviceType: DeviceType,
  response: Response
): Promise<DeviceState> => {
  const state = await getDeviceStateResponse(requestDeviceType, response);

  switch (deviceType) {
    case 'MediaRoom Play Set-Top Box':
      return {
        deviceType: requestDeviceType,
        name:
          MEDIAROOM_PLAY_STATE_NAMES[requestDeviceType] ?? requestDeviceType,
        state: deviceStateTranslation(state),
      };
    default:
      return {
        deviceType: requestDeviceType,
        name: requestDeviceType,
        state: deviceStateTranslation(state),
      };
  }
};

const MEDIAROOM_PLAY_STATE_NAMES: Partial<Record<DeviceType, string>> = {
  'MediaRoom Set-Top Box': 'TV Status',
  'MediaRoom Play Set-Top Box': 'Cloud Status',
};

const getDeviceStateResponse = async (
  requestDeviceType: DeviceType,
  response: Response
) => {
  switch (requestDeviceType) {
    case 'ONT ZNID':
    case 'Cable Modem':
      const state = response.ok ? await response.json() : undefined;
      return state.Description ?? 'Unknown';
    default:
      return response.ok
        ? await response
            .clone()
            .json()
            .catch(() => response.text())
        : 'Unknown';
  }
};

const deviceStateTranslation = (state: string) => {
  switch (state) {
    case 'PowerOn':
    case 'Device Online':
      return 'Online';
    case 'Invalid':
    case 'Offline':
    case 'OffLine':
    case 'Device Offline':
    case 'Device Not Found':
    case 'Unknown Device':
      return 'Offline';
    case 'N/A':
    case 'Unknown':
      return 'Unknown';
    default:
      return state;
  }
};

export const getDeviceStateText = (deviceState: DeviceState[]) => {
  const stateCount = deviceState.length;
  const onlineCount = deviceState.reduce((result, deviceState) => {
    if (deviceState.state === 'Online') result++;

    return result;
  }, 0);

  if (deviceState.length === 0) return 'Unknown';
  else if (deviceState.every((s) => s.state === 'Online')) return 'Online';
  else if (deviceState.every((s) => s.state === 'Offline')) return 'Offline';
  else if (deviceState.every((s) => s.state === 'Unknown' || s.state === ''))
    return 'Unknown';
  else if (stateCount > 1 && onlineCount !== stateCount)
    return 'Partially Online';
  else if (onlineCount !== stateCount && stateCount === 1)
    return deviceState[0].state;
  return 'Unknown';
};
